"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation changeEventDate($eventId: String!, $newStartsAt: Int!) {
    changeEventDate(eventId: $eventId, newStartsAt: $newStartsAt) {
      event {
        _id
        name
      }
      ordersUpdated
      tasksUpdated
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=changesEventDate.mutation.js.map